module.exports = __webpack_public_path__ + "static/media/rebelPhase1Image3.d1a980f4.png";